/*
 * Old polyfill.. TODO: understand if its needed
jQuery(window).on('ready', function() {
  if ( !NodeList.prototype.forEach ) {NodeList.prototype.forEach = Array.prototype.forEach;}
});
 */

export function showSub(cat_id) {
  var sub = jQuery('#subs_cat_'+cat_id);
  if (sub.hasClass('open'))
    sub.removeClass('open');
  else
    sub.addClass('open');
}

export function addCat(id, target) {
  //cats = document.getElementById(target);
  let cat_row = document.getElementById('cat_'+parseInt(id) );

  let actual_values;
  if (target.value.hasOwnProperty('length')) {
    if (target.value.length == 0)
      actual_values = [];
    else
      actual_values = target.value.split(/,/);
    var length = actual_values.length;
    for(var i = 0; i < length; i++) {
      if(actual_values[i] == id)
        return;
    }
    actual_values.push(id);
    cat_row.className += ' green lighten-4';
  }
  else {
    if (target.value != "")
    {
      let now = target.value.split(/,/);
      now.forEach( x => {
        removeHighlightCat( x, target);
      });
    }
    actual_values = [];
    actual_values.push(id);
  }

  target.value = actual_values.toString();
}

export function removeCat(id, target) {
  //cats = document.getElementById(target);
  let cat_row = document.getElementById('cat_'+id);

  let actual_values;
  if (target.value.length === 0)
    return;
  else
    actual_values = target.value.split(/,/);
  var length = actual_values.length;
  var found = -1;
  for(var i = 0; i < length; i++) {
    if(actual_values[i] == id)
      found = i; }
  if (found == -1)
    return;
  actual_values.splice(found, 1);

  target.value = actual_values.toString();
  cat_row.className = cat_row.className.replace(' green lighten-4','');
}

export function addCatAndSub(id, target) {
  addCat(id, target);
  var cats_childs = document.getElementById('subs_cat_'+id);
  if (cats_childs == null)
  {
    return;
  }
  var list = cats_childs.childNodes;
  list.forEach(function ( entry ) {
    if (!jQuery(entry).hasClass('subcats'))
    {
      var tmp_id = entry.id.replace('cat_','');
      addCatAndSub(tmp_id, target);
    }

  });
}

export function removeCatAndSub(id, target) {
  removeCat(id, target);
  var cats_childs = document.getElementById('subs_cat_'+id);
  if (cats_childs == null)
  {
    return;
  }
  var list = cats_childs.childNodes;
  list.forEach(function ( entry ) {
    if (!jQuery(entry).hasClass('subcats'))
    {
      var tmp_id = entry.id.replace('cat_','');
      removeCatAndSub(tmp_id, target);
    }
  });
}
